import React from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet";
import { pageTitle } from "../../components/shared/basic/customHead";
import LiveStreamDashboard from "../../components/LiveComp/live-stream-dashboard";

const LivePage = () => {
  return (
    <div>
      <Helmet>
        <title>{pageTitle("Live")}</title>
      </Helmet>
      <div className="relative">
        <LiveStreamDashboard />
      </div>
      <Outlet />
    </div>
  );
};

export default LivePage;
